import Snackbar from 'components/@extended/Snackbar'
import Locales from 'components/Locales'
import RTLLayout from 'components/RTLLayout'
import ScrollTop from 'components/ScrollTop'
import useConfig from 'hooks/useConfig'
import { ToastContainer } from 'react-toastify'
import Routes from 'routes'
import ThemeCustomization from 'themes'

import { AuthProvider } from 'hooks/AuthProvider'
import 'react-toastify/dist/ReactToastify.css'

const App = () => {
  const { mode } = useConfig()

  const authConfig = {
    authServerUrl: process.env.REACT_APP_GT_AUTH_URL || 'https://localhost:3000',
    currentAppName: process.env.REACT_APP_NAME || 'Plan Vital'
  }

  return (
    <AuthProvider config={authConfig}>
      <ThemeCustomization>
        <RTLLayout>
          <Locales>
            <ScrollTop>
              <>
                <Routes />
                <Snackbar />
                <ToastContainer
                  position="bottom-right"
                  theme={mode}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  style={{ width: '450px' }}
                />
              </>
            </ScrollTop>
          </Locales>
        </RTLLayout>
      </ThemeCustomization>
    </AuthProvider>
  )
}

export default App
